/**
 * Surface card with a pointer-tracking spotlight. The handler writes the
 * cursor's horizontal position into --mx, which the ::after gradient reads.
 */
export default function Card({ className = '', children, ...rest }) {
  const handlePointerMove = (event) => {
    const el = event.currentTarget;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${((event.clientX - rect.left) / rect.width) * 100}%`);
  };

  return (
    <div className={`card ${className}`.trim()} onPointerMove={handlePointerMove} {...rest}>
      {children}
    </div>
  );
}
